import { NodeType } from "../../../Dag.types";

export const hideRootNode = (nodes: NodeType[]) =>
  nodes.map((node: NodeType) => (!node?.data?.id ? { ...node, hidden: true } : node));
